module.exports = __webpack_public_path__ + "img/h5.cb6d78d1.png";